import React, { useEffect, useState } from 'react';
import { Modal, Icon, Tooltip } from 'antd';
import { useDispatch, useSelector } from 'react-redux';
import { fetchSpecialty, fetchSpecialtyFilter, SpecialtyClear, specialtyFilterClear } from 'app/actions/SpecialtyActions';
import { getSpecialty, getSpecialtyFilter, getIsLoadingSpecialty } from 'app/reducers';
import IconButton from '@material-ui/core/IconButton';
import ApiService from 'app/services/ApiService';
import { setTimeout } from 'timers';
import isEmpty from 'app/utils/IsEmpty';
import { employeeById } from 'app/reducers';

export default function SpecialtyTableContainer(props) {
    const { classes } = props;
    const { confirm } = Modal;

    const pagination = props.pagination;
    const sorter = props.sorter;
    let offset = 0;
    let limit = 0;
    let column = null;
    let order = null;
    let trainingfil = false;

    const employeeData = useSelector(employeeById);
    const {
        filter
    } = useSelector(state => state.TrainingReducer);
    const { siteId } = useSelector(state => state.Auth);

    const columns = [
        {
            title: 'Nombre',
            dataIndex: 'specialtyName',
            key: 'specialtyName',
            sorter: true,
            width: 300,
            ellipsis: true

        },
        {
            title: 'Tipo de Capacitación',
            dataIndex: 'trainingName',
            key: 'trainingName',
            sorter: true,
            //width: 300,
            ellipsis: true
        },
        {
            title: 'Acciones',
            key: 'action',
            dataIndex: 'idSpecialty',
            fixed: 'right',
            width: 120,
            render: (text, record) => (
                <div className={classes.buttons}>

                    {
                        siteId === 'HUB' ?
                            <Tooltip placement="bottomLeft" title={'Eliminar'}>
                                <IconButton disabled={record.noRemovable} className={classes.deleteIcon} onClick={() => showConfirmDelete(record)}>
                                    <Icon type="delete" />
                                </IconButton>
                            </Tooltip>
                            :
                            null
                    }

                    <Tooltip placement="bottomLeft" title={siteId === 'HUB' ? 'Editar' : 'Visualizar'}>
                        <IconButton className={classes.editIcon} onClick={() => showTabEdit(record)}>
                            {
                                siteId === 'HUB' ?
                                    <Icon type="edit" />
                                    :
                                    <Icon type="eye" />
                            }
                        </IconButton>
                    </Tooltip>
                </div>
            )
        }
    ];

    const showTabEdit = (param) => {
        props.setRow(param);
        props.isVisibleForm(true);
        props.setIdSpecialty(param.idSpecialty);
        props.setNameSpecialty(param.specialtyName);
    }

    const showConfirmDelete = (param) => {
        confirm({
            title: '¿Eliminar Especialidad?',
            content: param.specialtyName,
            okText: 'Eliminar',
            okType: 'danger',
            cancelText: 'Cancelar',
            onOk() {
                props.setName(props.name.filter(x => x !== param.specialtyName));
                trainingfil = specialty.filter(s => s.training == param.training).length == 1 ? true : false;
                if (trainingfil) {
                    props.setNames(props.names.filter(x => x !== param.training));
                }


                return deleteSpecialty(param);
            },
            onCancel() { },
        });

    }

    async function deleteSpecialty(param) {
        await ApiService.deleteSpecialty(param.idSpecialty).then(res => {
            dispatch(SpecialtyClear());
            dispatch(fetchSpecialty({
                sortColumn: column,
                sortDir: order, offset: offset, limit: limit,
                training: trainingfil ? props.names.filter(x => x !== param.training).join(',') : props.names.join(','),
                specialtyName: props.name.filter(x => x !== param.specialtyName).join(','),
                subDirectionOrigin: employeeData.idSubdirection,
                employeeId: employeeData.employeeId
            }));
            dispatch(specialtyFilterClear());
            dispatch(fetchSpecialtyFilter({
                training: props.names.filter(x => x !== param.training).join(','),
                subDirectionOrigin: employeeData.idSubdirection
            }))
            const modal = Modal.success({
                title: `Eliminado Correctamente`,
                content: '',
            });

            setTimeout(function () {
                modal.destroy();
            }, 3000)

        });
    }

    let specialty = useSelector(getSpecialty);
    let specialtyFilter = useSelector(getSpecialtyFilter);

    let isLoading = useSelector(getIsLoadingSpecialty);
    const dispatch = useDispatch();

    useEffect(() => {
        if (isEmpty(specialty)) fetchSpecialtyAction();
        if (isEmpty(specialtyFilter)) fetchSpecialtyFilterAction();
    }, []);

    const handleTableChange = (pagination, filters, sorter) => {

        props.setPagination(pagination);
        props.setSorter(sorter);
        if (Object.keys(sorter).length > 0) {
            column = sorter.field;
            order = sorter.order === "ascend" ? "ASC" : "DESC";
        }
        else {
            column = '';
            order = '';
        }
   
        dispatch(fetchSpecialty(
            {
                CommunicationProgramName: (typeof props.formData.CommunicationProgramName === "undefined") ? '' : props.formData.CommunicationProgramName,
                CommunicationProgramDescription: (typeof props.formData.CommunicationProgramDescription === "undefined") ? '' : props.formData.CommunicationProgramDescription,
                sortColumn: column,
                sortDir: order,
                offset: ((pagination.current - 1) * pagination.pageSize),
                limit: pagination.pageSize,
                subDirectionOrigin: employeeData.idSubdirection,
                employeeId: employeeData.employeeId,
                training: props.names.join(','),
                specialtyName: props.name.join('|')
            }));
    };

    //Load
    if (pagination != null) {
        offset = (0 * pagination.pageSize);
        limit = (pagination.pageSize);

        if (!isLoading && specialty.length > 0) {
            pagination.total = specialty[0].totalcount;
        }
        else {
            pagination.total = 0;
        }
    }

    if (sorter != null) {
        column = sorter.field;
        order = sorter.order === "ascend" ? "ASC" : "DESC";
    }

    const fetchSpecialtyAction = () => dispatch(fetchSpecialty({
        sortColumn: column,
        sortDir: order, offset: offset, limit: limit,
        training: props.names !== undefined ? props.names.join(",") : '',
        specialtyName: props.name !== undefined ? props.name.join(',') : '',
        subDirectionOrigin: employeeData.idSubdirection,
        employeeId: employeeData.employeeId
    }));
    const fetchSpecialtyFilterAction = () => dispatch(fetchSpecialtyFilter({
        training: props.names !== undefined ? props.names.join(",") : '',
        subDirectionOrigin: employeeData.idSubdirection,
        employeeId: employeeData.employeeId
    }))
    return (props.children({ pagination: pagination, cols: columns, specialty, specialtyFilter, isLoading, handleTableChange: handleTableChange }));
}

